import { QueryClient } from '@tanstack/react-query';

// The single app-wide client (provided in main.tsx). Lives in its own module
// so out-of-tree writers (zustand stores) can invalidate the cache.
// Mutations don't auto-retry — clinical writes must surface failures explicitly.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
